import { trackFieldEntered, trackFormSubmit, trackFormSubmitHover } from 'tracking/form/analytics';

// this used as a page_element option required in track event sending to the Segment
export const FORM_PAGE_ELEMENT = 'Lead Form';

export default class FormAnalytics {
  constructor({ form, formSubmitButton, formFields, pageType = document.documentElement.className } = {}) {
    this.form = form;
    this.formSubmitButton = formSubmitButton;
    this.formFields = formFields;
    this.formName = this.form.attributes.name?.value;
    this.pageType = pageType;
  }

  attachAnalyticEvents() {
    this.attachFormSubmitHoverEvent();
    this.attachFormSubmitClickEvent();
    this.attachFieldEnteredEvents();
  }

  attachFormSubmitHoverEvent() {
    this.formSubmitButton.addEventListener('mouseenter', () => {
      trackFormSubmitHover(this.formName, this.pageType);
    });
  }

  attachFormSubmitClickEvent() {
    this.formSubmitButton.addEventListener('click', () => {
      trackFormSubmit(this.formName, this.pageType);
    });
  }

  attachFieldEnteredEvents() {
    Array.from(this.formFields).forEach((formElement) => {
      formElement.addEventListener('change', ({ currentTarget }) => {
        trackFieldEntered(currentTarget, this.formName, this.pageType);
      });
    });
  }
}
